



































export default {
  name: 'main-footer'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global/MainFooter.vue